export const dosage = {
  takeWith: "Take with",
  takeWithInstruction: "Take with {{ takeWith }}",
  takeWithPill: "With {{ takeWith }}",
  reasonForTaking: "Reason for taking",
  reasonForTakingInstruction: "For {{ reasonForTaking }}",
  notSelected: "Not selected",
  dosageNonNumeric: "Dosage must be numeric",
  serving: " serving",
  serving_plural: " servings",
  additionalNotes: "Additional notes",

  // "Take with" options
  food: "Food",
  water: "Water",
  emptyStomach: "Empty stomach",

  // Reason for taking options
  adrenalSupport: "Adrenal support",
  antioxidantSupport: "Antioxidant support",
  bonesJointsAndMuscles: "Bones, joints, & muscles",
  childrenAndBabyHealth: "Children & baby health",
  energy: "Energy",
  eyeEarNoseAndThroat: "Eye, ear, nose, & throat",
  gutHealth: "Gut health",
  hairSkinAndNails: "Hair, skin, & nails",
  heartAndBloodHealth: "Heart & blood health",
  hormonalHealth: "Hormonal health",
  immuneAndInflammatoryHealth: "Immune & inflammatory health",
  liverAndDetox: "Liver & detox",
  mensHealth: "Men's health",
  mentalHealthAndSleep: "Mental health & sleep",
  thyroidSupport: "Thyroid support",
  urinarySupport: "Urinary support",
  visionSupport: "Vision support",
  weightManagement: "Weight management",
  womensHealth: "Women's health",

  // Frequency
  frequency: "Frequency",
  oncePerDay: "Once per day",
  twicePerDay: "Twice per day",
  threeTimesPerDay: "Three times per day",
  fourTimesPerDay: "Four times per day",
  fiveTimesPerDay: "Five times per day",
  asNeeded: "As needed",
  anytimeFrequency: "{{frequency}} (Anytime)",

  // Time of day
  anytime: "Anytime",
  uponWaking: "Upon waking",
  morning: "Morning",
  afternoon: "Afternoon",
  evening: "Evening",
  bedtime: "Bedtime",
} as const;
